import { Box, Typography } from '@mui/material';
import { RadioQuestion } from 'src/suitability/engine/components/radio-question';
import type { TestStepProps } from 'src/suitability/engine/types';
import {
  Q13_OTHER_QUESTION,
  type ConsilioAnswers,
  type ScoredQuestionKey,
} from './answers';
import { toRadioOptions, useConsilioContent } from './content';

interface ScoredBlockProps extends TestStepProps<ConsilioAnswers> {
  stepKey: string;
  questions: readonly ScoredQuestionKey[];
}

export const ScoredBlock = ({
  answers,
  onUpdate,
  stepKey,
  questions,
}: ScoredBlockProps) => {
  const content = useConsilioContent();
  const step = content.step(stepKey);

  return (
    <Box>
      <Typography variant="textXl" sx={{ fontWeight: 700, mb: 1 }}>
        {step.title}
      </Typography>
      {step.intro && (
        <Typography
          variant="textSm"
          sx={{ color: 'text.secondary', mb: 3, display: 'block' }}
        >
          {step.intro}
        </Typography>
      )}

      {questions.map((question) => {
        const questionContent = content.question(question);
        const answer = answers[question];
        const withText = question === Q13_OTHER_QUESTION;

        return (
          <RadioQuestion
            key={question}
            question={questionContent.prompt}
            options={toRadioOptions(question, questionContent)}
            value={answer === undefined ? undefined : String(answer)}
            onChange={(value) =>
              onUpdate({
                [question]: Number(value),
              } as Partial<ConsilioAnswers>)
            }
            text={withText ? answers.q13Other : undefined}
            onTextChange={
              withText ? (text) => onUpdate({ q13Other: text }) : undefined
            }
            required
          />
        );
      })}
    </Box>
  );
};
